export { default as LocaleProvider } from './LocaleProvider';
export { default as withLocale } from './LocaleConsumer';
